import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import { DarkButton } from '@acko-tech/building-blocks.ui.button';
import React from 'react';
import CarSurvey from '@/assets/Icons/car-survey.svg';
import AlertCautionIcon from '@/assets/Icons/alert-caution.svg';
import { useRouter } from 'next/router';
import useOnce from '@/hooks/useOnce';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_MMV_NOT_SERVICEABLE } from '@/analytics/events';
import { getMMVDetails } from '../../utils';
interface Props {
    show: boolean;
    clickHandler: () => void;
    close: () => void;
    isNewFlow?: boolean;
    make?: string;
    editCarModal?: boolean;
    ctaClick?: () => void;
}

const NotServiceableModal = ({
    show,
    close,
    clickHandler,
    isNewFlow = false,
    make = '',
    editCarModal,
    ctaClick,
}: Props) => {
    const router = useRouter();
    const handleCall = () => {
        if (ctaClick) {
            ctaClick();
            return;
        }
        //window.open('tel:18002669293', '_self');
        if (editCarModal) {
            close();
        } else {
            router.back();
        }
    };
    useOnce(
        () =>
            show &&
            viewPageAPI({
                event_name: VIEW_PAGE_MMV_NOT_SERVICEABLE,
                customAttributes: {
                    ...getMMVDetails(),
                    saved_assets: localStorage.getItem('mmv') ? true : false,
                },
                isFakeDoor: true,
            })
    );
    return (
        <React.Fragment>
            <MobileOrDesktopDialog
                onClose={() => {}}
                show={show}
                title=""
                hideClose
            >
                {isNewFlow ? <AlertCautionIcon /> : <CarSurvey />}
                <div className="title">
                    {isNewFlow
                        ? `We don’t provide service for ${make} cars at the moment, but we are expanding our capacity soon `
                        : `Hey! we’re unable to offer a quote for your vehicle right
                    now.`}
                </div>
                <div className="body">
                    {isNewFlow
                        ? `If you are looking for a car wash or similar services, please contact our customer care team.`
                        : `Not able to fetch vehicle Details`}
                </div>
                <div className="cta-container">
                    <DarkButton onClick={handleCall}>Okay</DarkButton>

                    <div className="link" onClick={clickHandler}>
                        Not this car? Add a new one
                    </div>
                </div>
            </MobileOrDesktopDialog>
            <style jsx>{`
                .cta-container {
                    margin: 1px 0 8px 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 20px;
                }
                .link {
                    font-weight: 500;
                    font-size: 14px;
                    color: #1b73e8;
                }
                .title {
                    color: #121212;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 28px; /* 140% */
                    margin-top: 16px;
                }
                .body {
                    color: #4b4b4b;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px; /* 150% */
                    margin: 16px 0 32px 0;
                }
            `}</style>
        </React.Fragment>
    );
};

export default NotServiceableModal;
